import { render, staticRenderFns } from "./siteAdminGroupForm.vue?vue&type=template&id=5ea1671e&scoped=true&"
import script from "./siteAdminGroupForm.vue?vue&type=script&lang=js&"
export * from "./siteAdminGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea1671e",
  null
  
)

export default component.exports